module.exports = __webpack_public_path__ + "static/media/logo-ifn.d42630fd.svg";